import { TownsquareSiteAri } from '@atlassian/ari';
import type { PreloadedQuery } from 'react-relay';

import type { RelayResourceConfig } from '@townsquare/relay-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { RouteResource } from '@townsquare/router/resources/types';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import DirectoryViewAggTableQuery, {
	type DirectoryViewAggTableQuery as DirectoryViewAggTableQueryType,
} from '../components/__generated__/DirectoryViewAggTableQuery.graphql';
import { DEFAULT_FIRST } from '../constants';
import { DEFAULT_GOAL_SORTS } from '../default-constants';
import { getDefaultGoalTqlQueryForRoute, resolveRawSort } from '../util';

export const getGoalDirectoryTableAggResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<DirectoryViewAggTableQueryType> => {
	const context = resourceContext as ResourceContext;
	const cloudId = context.workspace?.cloudId;

	if (!cloudId) {
		throw new Error('goalDirectoryTableAggResource: no cloudId available on resource context');
	}

	const containerId = TownsquareSiteAri.create({ siteId: cloudId }).toString();
	const searchString =
		routerContext.query.tql ?? getDefaultGoalTqlQueryForRoute(routerContext.route.name);
	const sort = resolveRawSort(routerContext.query.sort) ?? DEFAULT_GOAL_SORTS;

	return {
		environment: getAggRelayEnvironment(),
		query: DirectoryViewAggTableQuery,
		variables: {
			containerId,
			searchString,
			sort,
			first: DEFAULT_FIRST,
			after: null,
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const goalDirectoryTableAggResource: RouteResource<
	PreloadedQuery<DirectoryViewAggTableQueryType, Record<string, unknown>>
> = createRelayResource<DirectoryViewAggTableQueryType>({
	getQuery: getGoalDirectoryTableAggResourceQuery,
});
